import { Color, FontWeight } from '@billy/design-system'
import styled from '@emotion/styled'

export const labelColors = {
  default: Color.Green400,
  success: Color.Green400,
  warning: Color.Yellow400,
  danger: Color.Red700,
  notification: Color.Lavender500,
}

type LabelContainerProps = { variant: keyof typeof labelColors }

export const LabelContainer = styled.span<LabelContainerProps>`
  padding: 1px 10px 2px 10px;
  border-radius: 2px;
  background-color: ${({ variant }) => labelColors[variant]};
  color: white;
  font-size: 14px;
  font-weight: ${FontWeight.Medium};
  line-height: 18px;
  white-space: nowrap;
`
